module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/top_key_visual-7410c036b6a5565b0b8eb62fb59f8e8d.png";